<div *ngIf="!loading" class="container my-4">
  <div class="row justify-content-center pb-4">
    <div class="col-lg-8">
      <div *ngIf="currentStep === PaymentStep.CONFIRM_METHOD">
        <om-confirm-payment-method
          [showBack]="showBack"
          [showSkip]="showSkip"
          [copay]="copay"
          [isCurrentMethodExpired]="currentPaymentMethod?.isExpired"
          [isNewInsurance]="isNewInsurance"
          (back)="goBack()"
          (update)="
            goToStep(isFlagM2Enabled && paymentMethods.length ? PaymentStep.SELECT_METHOD : PaymentStep.ADD_METHOD)
          "
          (confirm)="goToDestination()"
          (skip)="goToDestination()"
          (analytics)="trackAnalytics($event)"
        ></om-confirm-payment-method>
      </div>
      <div *ngIf="currentStep === PaymentStep.COPAY_REQUIRED">
        <om-copay-required
          [showBack]="showBack"
          [showSkip]="showSkip"
          [copay]="copay"
          (back)="goBack()"
          (add)="
            goToStep(isFlagM2Enabled && paymentMethods.length ? PaymentStep.SELECT_METHOD : PaymentStep.ADD_METHOD)
          "
          (skip)="goToDestination()"
          (analytics)="trackAnalytics($event)"
        ></om-copay-required>
      </div>
      <div *ngIf="currentStep === PaymentStep.SELECT_METHOD">
        <om-select-payment-method
          [showBack]="showBack"
          [showSkip]="showSkip"
          [canSetDefault]="canSetDefault"
          [paymentMethods]="paymentMethods"
          (back)="goBack()"
          (refreshData)="refreshPaymentMethods()"
          (add)="goToStep(PaymentStep.ADD_METHOD)"
          (confirm)="goToDestination()"
          (skip)="goToDestination()"
          (analytics)="trackAnalytics($event)"
        ></om-select-payment-method>
      </div>
      <div *ngIf="currentStep === PaymentStep.ADD_METHOD">
        <om-add-payment-method
          [showBack]="showBack"
          [showSkip]="showSkip"
          [canSetDefault]="canSetDefault"
          [currentPaymentMethod]="currentPaymentMethod"
          [isFlagM2Enabled]="isFlagM2Enabled"
          (back)="goBack()"
          (save)="goToDestination()"
          (skip)="goToDestination()"
          (analytics)="trackAnalytics($event)"
        ></om-add-payment-method>
      </div>
    </div>
  </div>
</div>
